import React from 'react';
import NavLink from 'ui-components/NavLink';
import xClass from 'utils/xClass';

const NavArrows = ({
	next,
	previous,
	mouseSide
}) => (
    <div id="navarrows">
		<NavLink
			key="previous"
			title="previous"
			className={xClass(
				"navarrow",
				"arrow-left",
				{active: mouseSide === -1}
			)}
			onClick={previous}
		/>
		<NavLink
			key="next"
			onClick={next}
			className={xClass(
				"navarrow",
				"arrow-right",
				{active: mouseSide === 1}
			)}
			title="next"
		/>
	</div>
)
export default NavArrows;